"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var react_i18next_1 = require("react-i18next");
var react_toastify_1 = require("react-toastify");
var network_1 = require("../../network");
var reducer_1 = require("../../store/restaurant/reducer");
var FullPageLoader_1 = require("../../components/Shared/FullPageLoader");
var CatalogHeader_1 = require("./CatalogHeader");
var Catalog_1 = require("./Catalog");
var CatalogBasket_1 = require("./CatalogBasket");
var Navigation_1 = require("../../components/Navigation");
var utils_1 = require("../../utils/utils");
var Product_1 = require("../Product/Product");
var CatalogBasketModal_1 = require("./CatalogBasketModal");
var store_1 = require("../../store/store");
require("./catalog.scss");
exports.CatalogPage = react_1.default.memo(function () {
    var location = (0, react_router_1.useLocation)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var menuId = searchParams.get('menu_id') || '';
    var tableQuery = searchParams.get('table') || '';
    var _a = (0, react_1.useState)(false), showBasket = _a[0], setShowBasket = _a[1];
    var items = (0, react_redux_1.useSelector)(function (state) { return state.cart; }).items;
    var currency = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.currency; });
    var _b = (0, network_1.useGetRestaurant)({ id: restaurantId }), restaurant = _b.data, isRestaurantLoading = _b.isLoading;
    var totalVat = (0, utils_1.calculateSubtotalWithVAT)(items);
    var subtotal = (0, utils_1.calculateSubtotal)(items);
    var vat = (0, utils_1.calculateVAT)(items);
    var serviceCharge = 0.0;
    if (type == reducer_1.RestaurantDeliveryType.Dinein && (restaurant === null || restaurant === void 0 ? void 0 : restaurant.service_charge_percent) != null) {
        serviceCharge = totalVat * (restaurant.service_charge_percent / 100);
        if (restaurant.service_charge_round != null && restaurant.service_charge_round > 0) {
            serviceCharge = Math.ceil(serviceCharge / restaurant.service_charge_round) * restaurant.service_charge_round;
        }
    }
    var total = subtotal + vat + serviceCharge;
    var _c = (0, network_1.useGetRestaurantMenu)({
        id: restaurantId,
        type: type,
        options: { enabled: !!restaurantId },
    }), _d = _c.data, menus = _d === void 0 ? [] : _d, isCatalogLoading = _c.isLoading;
    var menuList = menus.map(function (menu) { return ({ label: menu.name, value: menu.id }); });
    menuList.unshift({ label: t('All menus'), value: '' });
    var filteredMenu = menuId ? menus.filter(function (menu) { return menu.id === menuId; }) : menus;
    var categories = filteredMenu.flatMap(function (menu) {
        return __spreadArray([], menu.categories, true);
    });
    console.log(menus);
    var isNotesAllowed = !!(restaurant === null || restaurant === void 0 ? void 0 : restaurant.order_notes_allowed);
    var basketProps = { totalVat: totalVat, subtotal: subtotal, vat: vat, serviceCharge: serviceCharge, total: total, isNotesAllowed: isNotesAllowed };
    var onOpenBasket = function () {
        setShowBasket(true);
    };
    (0, react_1.useEffect)(function () {
        if (tableQuery) {
            return;
        }
        if (restaurant) {
            var isDineIn = type === 'dinein';
            var isDelivery = type === 'delivery';
            var isPickUp = type === 'pickup';
            if (!isDineIn && !isDelivery && !isPickUp) {
                store_1.history.push({ pathname: "/store" });
            }
            if ((isDelivery && !restaurant.has_delivery) || (isDineIn && !restaurant.has_dine_in) || (isPickUp && !restaurant.has_takeaway)) {
                store_1.history.push({ pathname: "/store" });
            }
        }
        if (restaurant && !restaurant.is_open) {
            store_1.history.push({ pathname: "/store" });
            react_toastify_1.toast.info(t('Restaurant is closed'), {
                className: 'restaurant-is-closed',
                theme: 'dark',
                hideProgressBar: true,
                closeButton: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
            });
        }
    }, [restaurant, restaurantId]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isRestaurantLoading || isCatalogLoading ? ((0, jsx_runtime_1.jsx)(FullPageLoader_1.FullPageLoader, { color: "#8f9d4b" })) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "page-container" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "catalog-main-container" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "catalog-content" }, { children: [(0, jsx_runtime_1.jsx)(Navigation_1.Navigation, {}), (0, jsx_runtime_1.jsx)(CatalogHeader_1.CatalogHeader, {}), (0, jsx_runtime_1.jsx)(Catalog_1.Catalog, { menuList: menuList, categories: categories })] })), (0, jsx_runtime_1.jsx)(CatalogBasket_1.CatalogBasket, __assign({}, basketProps))] })), items.length !== 0 && !showBasket && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "view-order-mobile" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "basket-total-button-wrap" }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: "basket-total-button", onClick: onOpenBasket }, { children: [t('View Order'), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "basket-total-header-price" }, { children: [currency === null || currency === void 0 ? void 0 : currency.title, total.toFixed(2)] }))] })) })) }))), (0, jsx_runtime_1.jsx)(Product_1.Product, {}), (0, jsx_runtime_1.jsx)(CatalogBasketModal_1.CatalogBasketModal, __assign({ showBasket: showBasket, basketItemLength: items.length, setShowBasket: setShowBasket }, { children: (0, jsx_runtime_1.jsx)(CatalogBasket_1.CatalogBasket, __assign({}, basketProps, { showBasket: showBasket, setShowBasket: setShowBasket, className: "basket-show" })) }))] }))) }));
});
